import React, { ReactChild } from 'react';
import { constants } from '@minecraft.utils';
import { getEnvironment } from '@minecraft.environment';
import { SCREEN_NAMES } from '@blocs.common';
import { TranslateFn } from '@blocs.i18n';
import { gqlAccountStatusEnum as ACCOUNT_STATUS } from '@minecraft.graphql-types';
import { ApiError } from '../types';

const onboardingUrl = getEnvironment()?.ONBOARDING_URL;

const getForgotPasswordError = (error: ApiError, forEmailOnlyAuth: boolean, t: TranslateFn): ReactChild => {
  const defaultMessage = forEmailOnlyAuth
    ? t('common:globalError.accountNotFoundErrorEmailOnlyAuth')
    : t('common:globalError.accountNotFoundError');
  const errorObject = error?.graphQLErrors?.[0];
  const wrongStatusError = errorObject?.extensions?.exception?.errorCode === 21 || errorObject?.data?.errorCode === 21;
  const status = errorObject?.data?.errorData?.status;

  if (errorObject?.data?.errorCode === 20) {
    // this is an error code for user that can't recover password due restricted instance
    const { instance } = errorObject.data.errorData;
    const instanceInfo = constants.instanceConstants.find((i) => i.value === instance);

    return (
      <span>
        {errorObject.message}
        <br />
        Please log into <a href={`/login.${instanceInfo.link}`}>{instanceInfo.label}</a> with your username and
        password.
      </span>
    );
  }

  if (wrongStatusError) {
    switch (status) {
      case ACCOUNT_STATUS.UNCLAIMED:
        return (
          <>
            You cannot reset your password because you have not finished claiming your legacy account. Please click{' '}
            <a href={onboardingUrl} data-qa-id={`${SCREEN_NAMES.FORGOT_PASSWORD}-link-clickHere`}>
              here
            </a>{' '}
            and log in with your legacy username and password to finish claiming your account.
          </>
        );
      case ACCOUNT_STATUS.JOINED:
        return 'Please use your account email to reset your password.';
      case ACCOUNT_STATUS.UNVERIFIED:
        return errorObject?.data?.errorData['message'] || errorObject.message || defaultMessage;
      case ACCOUNT_STATUS.CLOSED:
        return (
          <>
            This account has been disabled. Please click <a href="/login/signup">here</a> to create a new account.
          </>
        );
      default:
        return defaultMessage;
    }
  }

  return null;
};

export default getForgotPasswordError;
